import React, {Component, Fragment} from "react";
import {Col, FormGroup, FormText, Input, InputGroup, Label, Row, TabContent, TabPane} from "reactstrap";
import {ToastContainer} from "react-toastify";
import {formsCheckboxUpdater, formsUpdater, getFormFieldValue, zPad} from "../Applications/shared/shared";
import "react-select/dist/react-select.min.css"
import {hourMarks, minMarks, statusMarks} from "../../constants/MiscData";
import {addHours, forceUTCTimeZone, formatDateLocal, makeDate} from "../../util/datehelpers";
import {postData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import {isNumber} from "../../util/numberhelpers";

export default class EventTaskEditor extends Component {

  constructor(props) {
    super(props);
    // console.log("tasks", props.task);
    this.state = {
      dataLoaded: false,
      formData: props.task || {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      activeTab: "task"
    };
    if (props.task) {
      const start = forceUTCTimeZone(makeDate(this.state.formData['dueon']));
      this.state.formData['startdate'] = formatDateLocal(start);
      this.state.formData['starthour'] = start.getHours();
      this.state.formData['startmin'] = start.getMinutes();
    }
    if (props['addSelection'] && Object.keys(props['addSelection']).length > 1) {
      const tempEvent = {};
      tempEvent['startdate'] = formatDateLocal(props.addSelection['start']);
      tempEvent['starthour'] = props.addSelection['start'].getHours();
      tempEvent['startmin'] = props.addSelection['start'].getMinutes();

      const endAt = props.addSelection['end'] || addHours(props.addSelection['start'], 1);
      tempEvent['enddate'] = formatDateLocal(endAt);
      tempEvent['endhour'] = endAt.getHours();
      tempEvent['endmin'] = endAt.getMinutes();

      if (tempEvent['starthour'] === 0 && tempEvent['startmin'] === 0 && tempEvent['endhour'] === 0 && tempEvent['endmin'] === 0) {
        tempEvent['allDay'] = true;
      }
      this.state.formData = tempEvent;
    }

  }

  componentWillMount() {
    EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
  }

  componentWillUnmount() {
    EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  saveInternval() {

  }

  save(cb) {
    const self = this;
    const payload = {
      formData: {
        title: "",
        data: "",
        status: 0,
        assignedTo: 0,
        ...this.state.formData
      }, action: isNumber(self.props.edit) ? "update" : "add"
    };
    payload.formData.assignedTo = Number(payload.formData.assignedTo || 0);
    payload.formData.starthour = Number(payload.formData.starthour || 0);
    payload.formData.startmin = Number(payload.formData.startmin || 0);
    payload.formData.status = Number(payload.formData.status || 0);
    payload.formData.allDay = payload.formData.allDay === 1 ? 1 : payload.formData.allDay === true ? 1 : 0;
    // console.log(payload);
    postData(`events/${this.props.eventId}/tasks/save`, payload, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          cb({...this.state.formData, ...data.data});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  // dateValidator(startUpdated) {
  //   const self = this;
  //   const dateBuilder = function (when) {
  //     let s = "".concat(self.state.formData[when + 'date'], " ", zPad(String(self.state.formData[when + 'hour'] || 0), 2), ":", zPad(String(self.state.formData[when + 'min'] || 0), 2), ":00");
  //     return s;
  //   }
  //   const momentDate = function (dateString) {
  //     return moment(dateString, "YYYY-MM-DD HH:mm:ss", true);
  //   }
  //   const startDate = momentDate(dateBuilder("start"));
  //   const endDate = momentDate(dateBuilder("end"));
  //   if (startUpdated === 'start') {
  //     if (startDate.isValid() && endDate.isValid()) {
  //       if (startDate.isAfter(endDate)) {
  //         formsMultiUpdater({
  //           enddate: this.state.formData.startdate,
  //           endhour: this.state.formData.starthour || 0,
  //           endmin: this.state.formData.startmin || 0
  //         }, this.state.formData, this);
  //       }
  //     } else if (startDate.isValid() && !endDate.isValid()) {
  //       formsMultiUpdater({
  //         enddate: this.state.formData.startdate,
  //         endhour: this.state.formData.starthour || 0,
  //         endmin: this.state.formData.startmin || 0
  //       }, this.state.formData, this);
  //     }
  //   } else {
  //     //end was the one changed
  //     if (endDate.isValid() && startDate.isValid()) {
  //       if (endDate.isBefore(startDate)) {
  //         formsMultiUpdater({
  //           startdate: this.state.formData.enddate,
  //           starthour: this.state.formData.endhour || 0,
  //           startmin: this.state.formData.endmin || 0
  //         }, this.state.formData, this);
  //       }
  //     } else if (endDate.isValid() && !startDate.isValid()) {
  //       formsMultiUpdater({
  //         startdate: this.state.enddate.formData,
  //         starthour: this.state.formData.endhour || 0,
  //         startmin: this.state.formData.endmin || 0
  //       }, this.state.formData, this);
  //     }
  //   }
  // }

  render() {
    const containerStyle = {
      zIndex: 2000
    };

    return (
      <Fragment>
        <ToastContainer position="bottom-right" autoClose={1500} style={containerStyle}/>
        {/*<Nav tabs>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'event'})}*/}
        {/*      onClick={() => this.toggleTab('event')}>*/}
        {/*      Event*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'additional'})}*/}
        {/*      onClick={() => this.toggleTab('additional')}>*/}
        {/*      Additional*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'links'})}*/}
        {/*      onClick={() => this.toggleTab('links')}>*/}
        {/*      Web Links*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'tasks'})}*/}
        {/*      onClick={() => this.toggleTab('tasks')}>*/}
        {/*      Tasks*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'notes'})}*/}
        {/*      onClick={() => this.toggleTab('notes')}>*/}
        {/*      Notes*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  <NavItem>*/}
        {/*    <NavLink*/}
        {/*      className={classnames({active: this.state.activeTab === 'files'})}*/}
        {/*      onClick={() => this.toggleTab('files')}>*/}
        {/*      Files*/}
        {/*    </NavLink>*/}
        {/*  </NavItem>*/}
        {/*  {isNumber(this.props.edit) && this.state.formData['starttime'] < Math.round((new Date()).getTime() / 1000) && (*/}

        {/*    <NavItem>*/}
        {/*      <NavLink*/}
        {/*        className={classnames({active: this.state.activeTab === 'aar'})}*/}
        {/*        onClick={() => this.toggleTab('aar')}>*/}
        {/*        AAR*/}
        {/*      </NavLink>*/}
        {/*    </NavItem>*/}
        {/*  )}*/}
        {/*</Nav>*/}
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="task">
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="title">Title*</Label>
                  <Input
                    type="text"
                    id="title"
                    value={getFormFieldValue(this.state.formData['title'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="assignedTo">Assigned To</Label>
                  <Input type="select" id="assignedTo" placeholder=""
                         value={getFormFieldValue(this.state.formData['assignedTo'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    <option value={"0"}>Anyone</option>
                    {(this.props.users || []).map((val, i) => {
                      return <option key={i} value={val.value}>{val.label}</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="status">Status</Label>
                  <Input type="select" id="status" placeholder=""
                         value={getFormFieldValue(this.state.formData['status'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    {(statusMarks || []).map((val, i) => {
                      return <option key={i} value={val}>{val}%</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="startdate">Due Date</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      id="startdate"
                      placeholder="date"
                      value={getFormFieldValue(this.state.formData['startdate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                        // this.dateValidator('start');
                      })}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    ex. 10/23/2019
                  </FormText>
                </FormGroup>
              </Col>

              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="starthour">Due Time</Label>
                  <div style={{display: 'flex'}}>
                    <Input type="select" id="starthour" placeholder=""
                           value={getFormFieldValue(this.state.formData['starthour'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             // this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {hourMarks.map((h, i) => <option key={i} value={h}>{zPad(String(h), 2)}</option>)}
                    </Input>
                    <Input type="select" id="startmin" placeholder=""
                           value={getFormFieldValue(this.state.formData['startmin'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             // this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {minMarks.map((m, i) => <option key={i} value={m}>{zPad(String(m), 2)}</option>)}
                    </Input>
                  </div>
                  <FormText color="muted">
                    ex. HH MM (15 45)
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="4" lg="2">
                <FormGroup check inline>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="allDay"
                         defaultChecked={getFormFieldValue(this.state.formData['allDay'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="allDay">All Day</Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="data">Details</Label>
                  <Input
                    type="textarea"
                    id="data"
                    cols={15}
                    style={{height: 150}}
                    value={getFormFieldValue(this.state.formData['data'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Events/EventTaskEditor.js